import { Requests } from '@nx-smartmonkey/shared/helpers';

import { capacitorService } from '../application/CapacitorService';
import configuration from './configuration';
import { Intercom, IntercomNative, IntercomWeb } from './intercom';
import { NetworkInterface, NetworkNative, NetworkWeb } from './network';
import { PostHogInterface, PostHogWeb } from './postHog';
import { CookiesInterface, CookiesNative, CookiesWeb } from './cookies';

export const requests = Requests.create(configuration.DRIVERS_BACK_END);
export const cookies: CookiesInterface = capacitorService.isNative() ? new CookiesNative() : new CookiesWeb();
export const network: NetworkInterface = capacitorService.isNative() ? new NetworkNative() : new NetworkWeb();
export const intercom: Intercom = capacitorService.isNative() ? new IntercomNative() : new IntercomWeb();
export const postHogService: PostHogInterface = new PostHogWeb();
